export * from './component';
export * from './const';
export * from './data';
export * from './utility';
export * from './shared.module';
export * from './pipes';



// WEBPACK FOOTER //
// ./src/app/modules/shared/index.ts